var _circle, _rect, _text, _circle2, _circle3, _circle4, _circle5, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.5,
    height: 145.5,
    viewBox: "0 0 145.5 145.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.75,
    cy: 72.75,
    r: 72.75,
    transform: "translate(-9.3 10.68) rotate(-7.89)",
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 45,
    width: 105,
    height: 55,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#624DE3",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 72.75,
    y: 85,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#624DE3"
  }, "$")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 57,
    r: 3,
    fill: "#624DE3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 88,
    r: 3,
    fill: "#624DE3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 57,
    r: 3,
    fill: "#624DE3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 88,
    r: 3,
    fill: "#624DE3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 50,
    width: 95,
    height: 45,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#624DE3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.2ab9a4f03d1cd04c51d700fea78d8679.svg";
export { ForwardRef as ReactComponent };